import React, { useState, useEffect, useRef } from 'react';
import { useSettings, useStore } from '../context/store';

export default function Sort( props ) {
    const {
        state,
        dispatch
    } = useStore();

    const settings = useSettings();

    const selectOption = option => {
        dispatch({ type: 'setSortBy', payload: option });
        toggleDropdown();
    }

    const toggleDropdown = () => {
        document.querySelector('.ygl-sort').classList.toggle('active');
    }

    if ( 'undefined' !== typeof state && state.listingCount > 0 ) {
        const pre = 'ygl-sort-bar';

        const currentSortBy = null !== state.sortBy ? state.sortBy : settings.sortBy[0];

        return (
            <div className="ygl-sort-bar">
                <div className="container">
                    <div className="ygl-sort-bar__results"><strong>{state.listingCount}</strong> results</div>

                    <div className="ygl-sort">
                        <button className="ygl-sort__button" onClick={ e => toggleDropdown() }>
                            <span>
                                <strong>Sort by: </strong>
                                {currentSortBy.name}
							</span>
                        </button>

                        <ul className="ygl-sort__dropdown">
                            {settings.sortBy.map((option, index) => {
                                return (
                                    <li key={ index } onClick={ e => selectOption( option ) }>{option.name}</li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
    
    return '';
}